module.exports = __webpack_public_path__ + "img/chevron-compact-left_secandary.5b8f78c8.svg";